import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import { Status } from '../../../../constants/reportConstants';
import getStatusOptions from '../../../../constants/statusOptions';

import { Option, Select } from '~/components/ui/select';
import { useToastNotificationContext } from '~/hooks/global/alert/useToastNotification';
import { useAppSelector } from '~/hooks/global/typedReduxHooks';

interface SelectStatusProps {
  selected: string;
  onChangeSelected: (e: string) => void;
  disabledFlag?: boolean | undefined;
}

const SelectStatus = ({
  selected,
  onChangeSelected,
  disabledFlag,
}: SelectStatusProps) => {
  const intl = useIntl();
  const statusOptions = getStatusOptions();
  const { createToastNotification } = useToastNotificationContext();
  const reportData = useAppSelector((state) => state.reportData.report);
  const userAccessRoles = useAppSelector(
    (state) => state.reportData.userAccessRoles,
  );

  const handleClick = () => {
    if (
      userAccessRoles.is_allowed_to_reopen_report == false &&
      (reportData.status == Status.ARCHIVED ||
        reportData.status == Status.CLOSED_NOT_ENOUGH_INFORMATION ||
        reportData.status == Status.CLOSED_RESOLVED ||
        reportData.status == Status.CLOSED_WHISTLEBLOWER_INITIATED)
    ) {
      createToastNotification(
        intl.formatMessage({
          defaultMessage: 'You are not permitted to reopen any reports',
        }),
        'warning',
      );
    }
  };

  const allowReopenReport = () => {
    if (
      disabledFlag == true &&
      userAccessRoles.is_allowed_to_reopen_report == true &&
      reportData.status !== Status.ARCHIVED
    ) {
      return false;
    } else if (
      disabledFlag == true &&
      userAccessRoles.is_allowed_to_reopen_report == false
    ) {
      return true;
    } else if (
      disabledFlag == false &&
      userAccessRoles.is_allowed_to_reopen_report == true
    ) {
      return false;
    } else if (
      userAccessRoles.is_allowed_to_reopen_report == false &&
      disabledFlag == false
    ) {
      return false;
    }
    return true;
  };

  const isDisabled = allowReopenReport();

  return (
    <Box onClick={handleClick}>
      <Select
        size='lg'
        disabled={isDisabled}
        controlled={false}
        value={Number(selected)}
        onChange={(_, value) => onChangeSelected(`${value ?? ''}`)}
        mountOptionsToRoot
      >
        {statusOptions.map((status) => (
          <Option
            key={status.id}
            disabled={
              disabledFlag &&
              userAccessRoles.is_allowed_to_reopen_report &&
              reportData.status !== 6 &&
              status.id > 2
            }
            value={status.id}
          >
            {status.name}
          </Option>
        ))}
      </Select>
    </Box>
  );
};

export default SelectStatus;
